import axiosServices from "../utils/axios";
import { convertToCamelCase, convertToSnakeCase } from "../utils/code-utils";

import type {
  DeliveryVendor,
  DeliveryUpdatePayload,
} from "../utils/types/delivery";

interface dataResponse {
  data: DeliveryVendor[];
}

export const fetchDeliveryList = async (berthId?: string, job_id?: string) => {
  // Build params object, only including non-undefined values
  const params: { [key: string]: any } = {};

  // Only add the parameters that are provided
  if (berthId) {
    params.bearthId = berthId; // Fixed: was "bearthId" (typo)
    params.jobId = job_id;
  }

  if (job_id) {
    params.jobId = job_id;
  }

  const response = await axiosServices.get<dataResponse>("/deliveryvendor", {
    params,
  });

  return convertToCamelCase<DeliveryVendor[]>(response.data.data);
};

export const updateDelivery = async (
  id: string,
  berthId?: string | undefined,
  jobId?: string | undefined,
  data?: {
    [key: string]: any;
    deliveryVendorId: string;
  }
) => {
  const params: { [key: string]: any } = {};
  if (data && jobId) {
    data.job_id = jobId; // Fixed: was "job_id" (typo)
  }
  if (berthId) {
    params.berthId = berthId; // Fixed: was "bearthId" (typo)
  }
  const inputData = convertToSnakeCase(data);
  await axiosServices.put(`deliveryvendor/${id}`, inputData, {
    params,
  });
};

export const fetchDeliveryVendorApi = async ({
  deliveryVendorId,
}: {
  deliveryVendorId: string;
}) => {
  const response = await axiosServices.get(
    `/deliveryVendor/${deliveryVendorId}`
  );
  return convertToCamelCase<DeliveryVendor[]>(response.data.data);
};

export const deleteDelivery = async (data: { id: string; berthId: string }) => {
  const response = await axiosServices.delete(`deliveryvendor/${data.id}`, {
    params: {
      berthId: data.berthId,
    },
  });
  return response.data;
};

export const addDelivery = async (data: DeliveryUpdatePayload) => {
  const payloadData = convertToSnakeCase(data);
  const response = await axiosServices.post<{ data: DeliveryVendor }>(
    "/deliveryvendor",
    payloadData,
    {
      params: {
        berthId: data.berthId,
      },
    }
  );
  return convertToCamelCase<DeliveryVendor>(response.data.data);
};

export const moveDelivery = async (id: string, berthId: string) => {
  await axiosServices.put(`/deliveryvendor/${id}`, {
    berth_id: berthId,
  });
};
